<agr-page-toolbar [pageTitle]="pageTitle$ | async">
  <app-advertisement-management-header
    [text]="'shared.advertisement-management-header.dashboard-message' | translate"
  ></app-advertisement-management-header>
  <app-table-header></app-table-header>
  <app-filter></app-filter>
  <app-overview-table></app-overview-table>
</agr-page-toolbar>
